var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.935,
    height: 9.935,
    viewBox: "0 0 9.935 9.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-edit",
    "data-name": "Icon material-edit",
    d: "M4.5,12.362v2.069H6.569l6.1-6.1L10.6,6.258Zm9.773-5.635a.55.55,0,0,0,0-.778L12.982,4.658a.55.55,0,0,0-.778,0l-1.01,1.01,2.069,2.069Z",
    transform: "translate(-4.5 -4.496)",
    fill: "#2b2d2f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a8290e9e55802c3634ae1f58abcb4771.svg";
export { ForwardRef as ReactComponent };